// Strip markdown syntax to produce a plain-text fallback used in <noscript>
// and meta descriptions. Intentionally simple — not a full parser.
export function markdownToPlainText(md: string): string {
  if (!md) return "";
  return md
    // code blocks
    .replace(/```[\s\S]*?```/g, "")
    // inline code
    .replace(/`([^`]+)`/g, "$1")
    // images
    .replace(/!\[[^\]]*\]\([^)]*\)/g, "")
    // links — keep text
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    // headings, blockquotes, list markers
    .replace(/^\s{0,3}(#{1,6}|>|[-*+]|\d+\.)\s+/gm, "")
    // bold / italic markers
    .replace(/(\*\*|__|\\*|_)/g, "")
    // horizontal rules
    .replace(/^\s*[-*_]{3,}\s*$/gm, "")
    // collapse whitespace
    .replace(/\r/g, "")
    .replace(/\n{2,}/g, "\n\n")
    .trim();
}

export function truncate(s: string, max: number): string {
  if (!s) return "";
  if (s.length <= max) return s;
  return s.slice(0, Math.max(0, max - 1)).trimEnd() + "…";
}

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}
